// TODO: Add more locales as they are supported by the remote config
export const SUPPORTED_LOCALES = {
  EN_AU: 'en-AU',
  DE_DE: 'de-DE',
} as const

export type SupportedLocale = typeof SUPPORTED_LOCALES[keyof typeof SUPPORTED_LOCALES]

export interface SupportedLocaleOption {
  locale: SupportedLocale
  /** Language name in its native language */
  nativeName: string
}

export const SUPPORTED_LOCALE_OPTIONS: Array<SupportedLocaleOption> = [
  {
    locale: SUPPORTED_LOCALES.EN_AU,
    nativeName: 'English',
  },
  {
    locale: SUPPORTED_LOCALES.DE_DE,
    nativeName: 'Deutsch',
  },
]
